import {fetchMediaConfig} from './wp-media-config.js';
import {createMediaFrame} from './wp-media-frame.js';
import {saveSelection} from './wp-media-save.js';

(function ($) {
    $(document).on('click', 'a[data-wp-toggle="media"]', async function (e) {
        e.preventDefault();

        const $link = $(this);
        const savePath = $link.attr('href');

        if (!savePath || savePath.startsWith('#')) {
            return;
        }

        const configUrl = $link.attr('data-wp-config');

        if (!configUrl) {
            alert('Chybí data-wp-config URL');
            return;
        }

        let config;

        try {
            config = await fetchMediaConfig(configUrl);
        } catch (err) {
            alert(err.message);
            return;
        }

        const multiple = $link.data('wp-multiple') !== false;
        const inputName = $link.data('wp-name') || 'ids';
        const initialState = String($link.data('wp-state') || 'browse')
            .trim()
            .toLowerCase();
        const mediaFrame = createMediaFrame({
            multiple,
            config,
            initialState,
            getCurrentValue: () => $link.data('wp-value') || '',
        });

        mediaFrame.on('close', function () {
            mediaFrame.detach();
        });

        // frame: 'post' používá primárně 'insert', 'select' jako fallback.
        const onConfirm = function () {
            const state = mediaFrame.state();
            const selection = state?.get('selection');
            const attachments = selection ? selection.toJSON() : [];

            saveSelection({
                savePath,
                inputName,
                multiple,
                attachments,
                $link,
            });
        };

        mediaFrame.on('insert', onConfirm);
        mediaFrame.on('select', onConfirm);

        mediaFrame.open();
    });
})(jQuery);
